import RequestArticleGroupCountryTax from 'src/adminPanel/entities/articleManagement/RequestArticleGroupCountryTax';
import RequestCountryTax from 'src/adminPanel/entities/articleManagement/RequestCountryTax';
import RequestGroupRebate from 'src/adminPanel/entities/articleManagement/RequestGroupRebate';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

export const FETCH_ARTICLE_GROUP = 'FETCH_ARTICLE_GROUP';
export const REQUEST_ARTICLE_GROUP = 'REQUEST_ARTICLE_GROUP';
export const SUCCESS_ARTICLE_GROUP = 'SUCCESS_ARTICLE_GROUP';
export const FAILURE_ARTICLE_GROUP = 'FAILURE_ARTICLE_GROUP';

export const fetchArticleGroup = (pageable?: PageableQueryParams, articleTypeId?: string) =>
    action(FETCH_ARTICLE_GROUP, { pageable, articleTypeId });
export const requestArticleGroup = () => action(REQUEST_ARTICLE_GROUP);
export const requestArticleGroupSuccess = (response: any) => action(SUCCESS_ARTICLE_GROUP, { response });
export const requestArticleGroupFailure = (error: any) => action(FAILURE_ARTICLE_GROUP, { error });

/* Group Rebate */
export const FETCH_GROUP_REBATES = 'FETCH_GROUP_REBATES';
export const REQUEST_GROUP_REBATES = 'REQUEST_GROUP_REBATES';
export const SUCCESS_GROUP_REBATES = 'SUCCESS_GROUP_REBATES';
export const FAILURE_GROUP_REBATES = 'FAILURE_GROUP_REBATES';

export const fetchGroupRebates = (articleTypeId: string, articleGroupId: string) =>
    action(FETCH_GROUP_REBATES, { articleTypeId, articleGroupId });
export const requestGroupRebates = () => action(REQUEST_GROUP_REBATES);
export const requestGroupRebatesSuccess = (response: any) => action(SUCCESS_GROUP_REBATES, { response });
export const requestGroupRebatesFailure = (error: any) => action(FAILURE_GROUP_REBATES, { error });

export const CREATE_NEW_GROUP_REBATE = 'CREATE_NEW_GROUP_REBATE';
export const REQUEST_CREATE_NEW_GROUP_REBATE = 'REQUEST_CREATE_NEW_GROUP_REBATE';
export const SUCCESS_CREATE_NEW_GROUP_REBATE = 'SUCCESS_CREATE_NEW_GROUP_REBATE';
export const FAILURE_CREATE_NEW_GROUP_REBATE = 'FAILURE_CREATE_NEW_GROUP_REBATE';

export const createNewGroupRebate = (groupRebateRequestDto: RequestGroupRebate) =>
    action(CREATE_NEW_GROUP_REBATE, { groupRebateRequestDto });
export const requestCreateNewGroupRebate = () => action(REQUEST_CREATE_NEW_GROUP_REBATE);
export const requestCreateNewGroupRebateSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_GROUP_REBATE, { response });
export const requestCreateNewGroupRebateFailure = (error: any) => action(FAILURE_CREATE_NEW_GROUP_REBATE, { error });

export const UPDATE_GROUP_REBATE = 'UPDATE_GROUP_REBATE';
export const REQUEST_UPDATE_GROUP_REBATE = 'REQUEST_UPDATE_GROUP_REBATE';
export const SUCCESS_UPDATE_GROUP_REBATE = 'SUCCESS_UPDATE_GROUP_REBATE';
export const FAILURE_UPDATE_GROUP_REBATE = 'FAILURE_UPDATE_GROUP_REBATE';

export const updateGroupRebate = (groupRebateRequestDto: RequestGroupRebate) =>
    action(UPDATE_GROUP_REBATE, { groupRebateRequestDto });
export const requestUpdateGroupRebate = () => action(REQUEST_UPDATE_GROUP_REBATE);
export const requestUpdateGroupRebateSuccess = (response: any) => action(SUCCESS_UPDATE_GROUP_REBATE, { response });
export const requestUpdateGroupRebateFailure = (error: any) => action(FAILURE_UPDATE_GROUP_REBATE, { error });

export const DELETE_GROUP_REBATE = 'DELETE_GROUP_REBATE';
export const REQUEST_DELETE_GROUP_REBATE = 'REQUEST_DELETE_GROUP_REBATE';
export const SUCCESS_DELETE_GROUP_REBATE = 'SUCCESS_DELETE_GROUP_REBATE';
export const FAILURE_DELETE_GROUP_REBATE = 'FAILURE_DELETE_GROUP_REBATE';

export const deleteGroupRebate = (
    articleTypeId: string,
    articleGroupId: string,
    minQuantity: string,
    premiumLevel: string
) => action(DELETE_GROUP_REBATE, { articleTypeId, articleGroupId, minQuantity, premiumLevel });
export const requestDeleteGroupRebate = () => action(REQUEST_DELETE_GROUP_REBATE);
export const requestDeleteGroupRebateSuccess = (response: any) => action(SUCCESS_DELETE_GROUP_REBATE, { response });
export const requestDeleteGroupRebateFailure = (error: any) => action(FAILURE_DELETE_GROUP_REBATE, { error });

/* Country Taxt */
export const FETCH_ARTICLE_COUNTRY_TAXES = 'FETCH_ARTICLE_COUNTRY_TAXES';
export const REQUEST_ARTICLE_COUNTRY_TAXES = 'REQUEST_ARTICLE_COUNTRY_TAXES';
export const SUCCESS_ARTICLE_COUNTRY_TAXES = 'SUCCESS_ARTICLE_COUNTRY_TAXES';
export const FAILURE_ARTICLE_COUNTRY_TAXES = 'FAILURE_ARTICLE_COUNTRY_TAXES';

export const fetchArticleCountryTaxes = (articleTypeId: string, articleGroupId: string) =>
    action(FETCH_ARTICLE_COUNTRY_TAXES, { articleTypeId, articleGroupId });
export const requestArticleCountryTaxes = () => action(REQUEST_ARTICLE_COUNTRY_TAXES);
export const requestArticleCountryTaxesSuccess = (response: any) => action(SUCCESS_ARTICLE_COUNTRY_TAXES, { response });
export const requestArticleCountryTaxesFailure = (error: any) => action(FAILURE_ARTICLE_COUNTRY_TAXES, { error });

export const CREATE_NEW_ARTICLE_COUNTRY_TAX = 'CREATE_NEW_ARTICLE_COUNTRY_TAX';
export const REQUEST_CREATE_NEW_ARTICLE_COUNTRY_TAX = 'REQUEST_CREATE_NEW_ARTICLE_COUNTRY_TAX';
export const SUCCESS_CREATE_NEW_ARTICLE_COUNTRY_TAX = 'SUCCESS_CREATE_NEW_ARTICLE_COUNTRY_TAX';
export const FAILURE_CREATE_NEW_ARTICLE_COUNTRY_TAX = 'FAILURE_CREATE_NEW_ARTICLE_COUNTRY_TAX';

export const createNewArticleCountryTax = (countryTaxRequest: RequestArticleGroupCountryTax) =>
    action(CREATE_NEW_ARTICLE_COUNTRY_TAX, { countryTaxRequest });
export const requestCreateNewArticleCountryTax = () => action(REQUEST_CREATE_NEW_ARTICLE_COUNTRY_TAX);
export const requestCreateNewArticleCountryTaxSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_ARTICLE_COUNTRY_TAX, { response });
export const requestCreateNewArticleCountryTaxFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_ARTICLE_COUNTRY_TAX, { error });

export const UPDATE_ARTICLE_COUNTRY_TAX = 'UPDATE_ARTICLE_COUNTRY_TAX';
export const REQUEST_UPDATE_ARTICLE_COUNTRY_TAX = 'REQUEST_UPDATE_ARTICLE_COUNTRY_TAX';
export const SUCCESS_UPDATE_ARTICLE_COUNTRY_TAX = 'SUCCESS_UPDATE_ARTICLE_COUNTRY_TAX';
export const FAILURE_UPDATE_ARTICLE_COUNTRY_TAX = 'FAILURE_UPDATE_ARTICLE_COUNTRY_TAX';

export const updateArticleCountryTax = (countryTaxRequest: RequestArticleGroupCountryTax) =>
    action(UPDATE_ARTICLE_COUNTRY_TAX, { countryTaxRequest });
export const requestUpdateArticleCountryTax = () => action(REQUEST_UPDATE_ARTICLE_COUNTRY_TAX);
export const requestUpdateArticleCountryTaxSuccess = (response: any) =>
    action(SUCCESS_UPDATE_ARTICLE_COUNTRY_TAX, { response });
export const requestUpdateArticleCountryTaxFailure = (error: any) =>
    action(FAILURE_UPDATE_ARTICLE_COUNTRY_TAX, { error });

export const DELETE_ARTICLE_COUNTRY_TAX = 'DELETE_ARTICLE_COUNTRY_TAX';
export const REQUEST_DELETE_ARTICLE_COUNTRY_TAX = 'REQUEST_DELETE_ARTICLE_COUNTRY_TAX';
export const SUCCESS_DELETE_ARTICLE_COUNTRY_TAX = 'SUCCESS_DELETE_ARTICLE_COUNTRY_TAX';
export const FAILURE_DELETE_ARTICLE_COUNTRY_TAX = 'FAILURE_DELETE_ARTICLE_COUNTRY_TAX';

export const deleteArticleCountryTax = (articleGroupCountryTaxId: string) =>
    action(DELETE_ARTICLE_COUNTRY_TAX, { articleGroupCountryTaxId });
export const requestDeleteArticleCountryTax = () => action(REQUEST_DELETE_ARTICLE_COUNTRY_TAX);
export const requestDeleteArticleCountryTaxSuccess = (response: any) =>
    action(SUCCESS_DELETE_ARTICLE_COUNTRY_TAX, { response });
export const requestDeleteArticleCountryTaxFailure = (error: any) =>
    action(FAILURE_DELETE_ARTICLE_COUNTRY_TAX, { error });
